export default "__VITE_ASSET__BCES$GpO__"